import { MenuItem } from 'primeng/api';
import { BulkActionConfig } from '../bulk-action-dialog/bulk-action-dialog.component';

/**
 * Menu state and initialization logic extracted from HomeComponent.
 * Handles construction and management of all menu items.
 */
export class MenuStateLogic {
  /**
   * Initialize bulk action configurations
   */
  static initializeBulkActions(): BulkActionConfig[] {
    return [
      {
        id: 'export',
        label: 'Export Notes...',
        description: 'Export the selected notes to PDF, DOCX, or JSON.',
        requiresParams: true,
      },
      {
        id: 'print',
        label: 'Print',
        description: 'Print the selected notes as a PDF document.',
        requiresParams: false,
      },
      {
        id: 'set-category',
        label: 'Set Category',
        description: 'Assign a category to all selected notes.',
        requiresParams: true,
      },
      {
        id: 'set-status',
        label: 'Set Status',
        description: 'Update the status for all selected notes.',
        requiresParams: true,
      },
      {
        id: 'add-tags',
        label: 'Add Tags',
        description: 'Add one or more existing tags to all selected notes.',
        requiresParams: true,
      },
      {
        id: 'remove-tags',
        label: 'Remove Tags',
        description: 'Remove all tags or selected tags from the selected notes.',
        requiresParams: true,
      },
      {
        id: 'set-favorite',
        label: 'Set Favorite (future!)',
        description: 'Update favorite status for the selected notes.',
        requiresParams: true,
      },
      {
        id: 'clear-category',
        label: 'Clear Category',
        description: 'Remove all categories from the selected notes.',
        requiresParams: false,
      },
      {
        id: 'delete',
        label: 'Delete',
        description: 'Permanently delete the selected notes.',
        requiresParams: false,
      },
    ];
  }

  /**
   * Build menu items from bulk action configs
   */
  static buildBulkActionMenuItems(
    bulkActions: BulkActionConfig[],
    onActionSelected: (actionId: string) => void,
  ): MenuItem[] {
    return bulkActions.map((action) => ({
      label: action.label,
      command: () => onActionSelected(action.id),
    }));
  }
}
